export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-07_00.977ad18f.jpg";